import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { SearchBox } from "../../common/components";
import { PeopleService, Person } from "../../common";

@Component({
  selector: "people-search-box",
  templateUrl: "./people-search-box.html",
  standalone: false,
})
export class PeopleSearchBox implements OnInit {
  @Input() model: string;
  @Output() modelChange: EventEmitter<Person> = new EventEmitter<Person>();
  @Output() showPicker: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild("box") searchBox: SearchBox;
  @Input() allowAny: boolean;
  @Input() placeHolder: string;

  constructor(private peopleService: PeopleService) {}

  ngOnInit() {
    if (!this.placeHolder) this.placeHolder = "User";
  }

  search(criteria: string) {
    let cai = Person.extractCai(criteria);
    if (cai && criteria.length > cai.length) return; // criteria contains cai and display name

    if (!criteria) {
      this.showPicker.emit(criteria);
    } else {
      this.peopleService.get(criteria).subscribe(
        (person) => {
          console.log(person);
          if (person.userId && criteria === person.displayName) {
            this.setModel(person);
          }
        },
        (e) => {
          console.log(e);
          if (this.allowAny)
            this.modelChange.emit({ userId: criteria, displayName: criteria } as Person);
          else this.showPicker.emit(criteria);
        }
      );
    }
  }

  focus() {
    this.searchBox.focus();
  }

  setModel(person: Person) {
    this.modelChange.emit(person);
  }
}
